module.exports = __webpack_public_path__ + "img/suenching_kapelle_altar_2017_ref.afa35bda.jpg";